import { Property, BlogPost } from '../types';
import { propertyPlaceholders, blogPlaceholders } from '../utils/placeholders';

export const sampleProperties: Property[] = [
  {
    id: '1',
    title: 'Luxury Villa in Kochi',
    description: 'Beautiful 3BHK villa with modern amenities, located in the heart of Kochi. Perfect for NRIs looking for a premium property.',
    price: 8500000,
    location: 'Marine Drive',
    city: 'Kochi',
    state: 'Kerala',
    propertyType: 'villa',
    bedrooms: 3,
    bathrooms: 3,
    area: 2500,
    areaUnit: 'sqft',
    images: ['/pop3i-correct-banner.png', '/pop3i-original-banner.jpg', '/hero-background.jpg'],
    features: ['Modern Kitchen', 'Balcony', 'Parking', 'Security'],
    amenities: ['Swimming Pool', 'Gym', 'Club House', 'Garden'],
    status: 'available',
    createdAt: new Date('2024-01-15'),
    updatedAt: new Date('2024-01-15'),
    contactInfo: {
      name: 'John Mathew',
      phone: '+91 9645310500',
      email: 'john@pop3i.com'
    }
  },
  {
    id: '2',
    title: 'Apartment in Trivandrum',
    description: 'Spacious 2BHK apartment with sea view, ideal for investment or personal use.',
    price: 4500000,
    location: 'Kovalam',
    city: 'Trivandrum',
    state: 'Kerala',
    propertyType: 'residential',
    bedrooms: 2,
    bathrooms: 2,
    area: 1200,
    areaUnit: 'sqft',
    images: ['/pop3i-original-banner.jpg', '/kerala-backwaters-banner.jpg'],
    features: ['Sea View', 'Balcony', 'Parking'],
    amenities: ['Swimming Pool', 'Garden', 'Security'],
    status: 'available',
    createdAt: new Date('2024-01-10'),
    updatedAt: new Date('2024-01-10'),
    contactInfo: {
      name: 'Sarah Thomas',
      phone: '+91 9496913122',
      email: 'sarah@pop3i.com'
    }
  },
  {
    id: '3',
    title: 'Commercial Space in Calicut',
    description: 'Prime commercial space in Calicut city center, perfect for business setup.',
    price: 12000000,
    location: 'Mavoor Road',
    city: 'Calicut',
    state: 'Kerala',
    propertyType: 'commercial',
    area: 5000,
    areaUnit: 'sqft',
    images: [propertyPlaceholders.commercial, '/pop3i-original-banner.jpg', '/kerala-backwaters-banner.jpg'],
    features: ['Main Road Access', 'Parking', 'Security'],
    amenities: ['Elevator', 'Power Backup', 'Water Supply'],
    status: 'available',
    createdAt: new Date('2024-01-05'),
    updatedAt: new Date('2024-01-05'),
    contactInfo: {
      name: 'Rajesh Kumar',
      phone: '+1 6238452598',
      email: 'rajesh@pop3i.com'
    }
  },
  {
    id: '4',
    title: 'Land Plot in Thrissur',
    description: 'Prime residential plot in Thrissur, ready for construction.',
    price: 2500000,
    location: 'Poonkunnam',
    city: 'Thrissur',
    state: 'Kerala',
    propertyType: 'land',
    area: 10,
    areaUnit: 'acres',
    images: [propertyPlaceholders.land, propertyPlaceholders.land],
    features: ['Road Access', 'Water Connection', 'Electricity'],
    amenities: ['Near School', 'Near Hospital', 'Near Market'],
    status: 'available',
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
    contactInfo: {
      name: 'Priya Nair',
      phone: '+1 6024456320',
      email: 'priya@pop3i.com'
    }
  },
  {
    id: '5',
    title: 'Modern House in Kottayam',
    description: 'Contemporary 4BHK house with traditional Kerala architecture.',
    price: 6500000,
    location: 'Kumarakom',
    city: 'Kottayam',
    state: 'Kerala',
    propertyType: 'house',
    bedrooms: 4,
    bathrooms: 3,
    area: 3000,
    areaUnit: 'sqft',
    images: [propertyPlaceholders.house, propertyPlaceholders.house, propertyPlaceholders.house, propertyPlaceholders.house],
    features: ['Traditional Design', 'Modern Kitchen', 'Balcony', 'Parking'],
    amenities: ['Garden', 'Pond', 'Security', 'Near Lake'],
    status: 'available',
    createdAt: new Date('2023-12-28'),
    updatedAt: new Date('2023-12-28'),
    contactInfo: {
      name: 'Vijay Menon',
      phone: '+91 9645310500',
      email: 'vijay@pop3i.com'
    }
  },
  {
    id: '6',
    title: 'Penthouse in Ernakulam',
    description: 'Luxury penthouse with panoramic city views, perfect for high-end living.',
    price: 15000000,
    location: 'MG Road',
    city: 'Ernakulam',
    state: 'Kerala',
    propertyType: 'residential',
    bedrooms: 3,
    bathrooms: 3,
    area: 4000,
    areaUnit: 'sqft',
    images: [propertyPlaceholders.residential, propertyPlaceholders.residential, propertyPlaceholders.residential],
    features: ['City View', 'Modern Kitchen', 'Balcony', 'Parking'],
    amenities: ['Swimming Pool', 'Gym', 'Club House', 'Concierge'],
    status: 'available',
    createdAt: new Date('2023-12-20'),
    updatedAt: new Date('2023-12-20'),
    contactInfo: {
      name: 'Anita George',
      phone: '+91 9496913122',
      email: 'anita@pop3i.com'
    }
  }
];

export const sampleBlogPosts: BlogPost[] = [
  {
    id: '1',
    title: 'Complete Guide to NRI Property Investment in Kerala',
    excerpt: 'Everything NRIs need to know about investing in Kerala real estate, from legal requirements to best locations.',
    content: 'Kerala has emerged as one of the most attractive destinations for NRI property investment in India. With its beautiful landscapes, growing infrastructure, and strong cultural ties, Kerala offers unique opportunities for NRIs looking to invest in real estate...',
    author: 'Dr. Rajesh Kumar',
    publishedAt: new Date('2024-01-15'),
    category: 'Investment Guide',
    tags: ['NRI', 'Investment', 'Kerala', 'Real Estate'],
    image: blogPlaceholders.investment,
    readTime: 8
  },
  {
    id: '2',
    title: 'Top 5 Emerging Property Markets in Kerala',
    excerpt: 'Discover the fastest-growing property markets in Kerala that offer excellent returns for investors.',
    content: 'Kerala\'s real estate market has been experiencing significant growth, with several emerging markets showing promising potential for investors. Here are the top 5 markets to watch...',
    author: 'Sarah Thomas',
    publishedAt: new Date('2024-01-10'),
    category: 'Market Analysis',
    tags: ['Market Analysis', 'Kerala', 'Investment', 'Growth'],
    image: blogPlaceholders.market,
    readTime: 6
  },
  {
    id: '3',
    title: 'Legal Requirements for NRI Property Purchase in India',
    excerpt: 'Understanding the legal framework and documentation required for NRIs to purchase property in India.',
    content: 'Purchasing property in India as an NRI involves specific legal requirements and documentation. This comprehensive guide covers all the essential legal aspects...',
    author: 'Adv. Priya Nair',
    publishedAt: new Date('2024-01-05'),
    category: 'Legal Guide',
    tags: ['Legal', 'NRI', 'Documentation', 'Property Purchase'],
    image: blogPlaceholders.legal,
    readTime: 10
  },
  {
    id: '4',
    title: 'Kerala\'s Infrastructure Development: Impact on Real Estate',
    excerpt: 'How Kerala\'s infrastructure projects are transforming the real estate landscape and creating new opportunities.',
    content: 'Kerala has been investing heavily in infrastructure development, including metro projects, airport expansions, and highway construction. These developments are significantly impacting the real estate market...',
    author: 'Vijay Menon',
    publishedAt: new Date('2023-12-28'),
    category: 'Infrastructure',
    tags: ['Infrastructure', 'Development', 'Kerala', 'Real Estate'],
    image: blogPlaceholders.infrastructure,
    readTime: 7
  },
  {
    id: '5',
    title: 'Sustainable Living: Eco-Friendly Properties in Kerala',
    excerpt: 'Explore Kerala\'s growing trend of sustainable and eco-friendly properties that align with environmental consciousness.',
    content: 'Kerala is leading the way in sustainable real estate development, with many properties incorporating eco-friendly features and green building practices...',
    author: 'Anita George',
    publishedAt: new Date('2023-12-20'),
    category: 'Sustainability',
    tags: ['Sustainability', 'Eco-Friendly', 'Green Building', 'Kerala'],
    image: blogPlaceholders.sustainability,
    readTime: 5
  }
];
